// UI Component: Toolbar
export class Toolbar {
  private element: HTMLElement;
  private callbacks: {
    onNew?: () => void;
    onOpen?: () => void;
    onSave?: () => void;
    onSaveAs?: () => void;
    onToggleTheme?: () => void;
    onHelp?: () => void;
    onSettings?: () => void;
  } = {};

  constructor(element: HTMLElement) {
    this.element = element;
    this.bindEvents();
  }

  private bindEvents(): void {
    const btnNew = this.element.querySelector('#btn-new');
    const btnOpen = this.element.querySelector('#btn-open');
    const btnSave = this.element.querySelector('#btn-save');
    const btnSaveAs = this.element.querySelector('#btn-save-as');
    const btnTheme = this.element.querySelector('#btn-theme');
    const btnHelp = this.element.querySelector('#btn-help');
    const btnSettings = this.element.querySelector('#btn-settings');

    btnNew?.addEventListener('click', () => this.callbacks.onNew?.());
    btnOpen?.addEventListener('click', () => this.callbacks.onOpen?.());
    btnSave?.addEventListener('click', () => this.callbacks.onSave?.());
    btnSaveAs?.addEventListener('click', () => this.callbacks.onSaveAs?.());
    btnTheme?.addEventListener('click', () => this.callbacks.onToggleTheme?.());
    btnHelp?.addEventListener('click', () => this.callbacks.onHelp?.());
    btnSettings?.addEventListener('click', () => this.callbacks.onSettings?.());
  }

  on(event: string, callback: () => void): void {
    if (event === 'new') this.callbacks.onNew = callback;
    if (event === 'open') this.callbacks.onOpen = callback;
    if (event === 'save') this.callbacks.onSave = callback;
    if (event === 'saveAs') this.callbacks.onSaveAs = callback;
    if (event === 'toggleTheme') this.callbacks.onToggleTheme = callback;
    if (event === 'help') this.callbacks.onHelp = callback;
    if (event === 'settings') this.callbacks.onSettings = callback;
  }

  updateSaveButton(enabled: boolean): void {
    const btnSave = this.element.querySelector('#btn-save') as HTMLButtonElement;
    if (btnSave) {
      btnSave.disabled = !enabled;
    }
  }
}
